import { AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/cn';
import { Button } from './button';

type InlineErrorProps = {
  message: string;
  onRetry?: () => void;
  retrying?: boolean;
  className?: string;
};

/**
 * A failed load, rendered in place of (or above) the content it failed to
 * fetch, with a retry. Never a toast: a toast disappears and leaves a screen
 * that reads as empty.
 */
export function InlineError({ message, onRetry, retrying = false, className }: InlineErrorProps) {
  return (
    <div role="alert" className={cn('flex flex-wrap items-center gap-2.5 rounded-card border border-line bg-head px-3.5 py-2.5 text-sm', className)}>
      <AlertTriangle className="size-4 shrink-0 text-neg-ink" aria-hidden="true" />
      <p className="m-0 min-w-0 flex-1">{message}</p>
      {onRetry ? (
        <Button size="sm" onClick={onRetry} loading={retrying}>
          Try again
        </Button>
      ) : null}
    </div>
  );
}
